
export enum ActionType {
    MESSAGE,
    LOADER,
    ALERT,
    LOAD_SESSION,
    LOGIN_BEGIN,
    LOGIN_SUCCESS,
    LOGOUT,
    SIDEBAR_OPEN,
    FETCH_PRACTICES,
    FETCH_ALL_PRACTICES,
    FETCH_PRACTICE,
    FETCH_REGIONS,
    FETCH_REGIONMANAGERS,
    FETCH_PMD_SCHEDULES,
    FETCH_PRACTICES_DB,
    SEND_FEEDBACK,
    SAVE_USAGE,
    PATIENT_VALIDATION_DEFAULT_PRACTICES,
    GET_HELP_MARK,
    INCREMENT,
    FETCH_UDA_INFO_PRACTICES,
    UPDATE_PRACTICES_OPTIONS,
    UPDATE_REGION_OPTIONS,
    UPDATE_BRANDS_OPTIONS,
    FETCH_ORTHO_PRACTICES,
    CREATE_BRACKET_SYSTEM,
    GET_REGIONS_SUCCESS,
    GET_REGIONS_FAIL,
    LOAD_USER_GROUPS_SUCCESS,
    LOAD_USER_GROUPS_FAIL,
    LOAD_USER_LIST_SUCCESS,
    LOAD_USER_LIST_FAIL,
    LOAD_GROUP_ATTACHES_SUCCESS,
    LOAD_GROUP_ATTACHES_FAIL,
    LOADER_GROUPS,
    LOAD_OD_DEFINITIONS_SUCCESS,
    LOAD_OD_DEFINITIONS_FAIL,

}

export interface Action<T> {
  type: ActionType;
  payload: T;
}
